<script lang="ts">
  import quote from "shell-quote/quote";

  import CodeSample from "$lib/ui/system/CodeSample.svelte";
  import { user } from "$lib/user";

  export let cliArgs: string[];
</script>

<div class="text-zinc-400 text-sm space-y-3">
  <div class="font-medium">
    <h2 class="text-xl text-white">Try this on Modal!</h2>
  </div>

  <p>You can run this example on Modal in 60 seconds.</p>

  {#if !$user?.logged_in}
    <div class="py-1">
      <a class="w-full btn btn-outlined btn-primary text-base" href="/signup">
        Create account to run
      </a>
    </div>

    <p>
      After creating a free account, install the Modal Python package, and
      create an API token.
    </p>

    <div class="py-1">
      <CodeSample
        source={["pip install modal", "modal setup"]}
        lang="bash"
        symbol="$"
      />
    </div>
  {/if}

  <p>
    Clone the
    <a
      class="text-zinc-300 font-semibold hover:underline"
      href="https://github.com/modal-labs/modal-examples">modal-examples</a
    > repository and run:
  </p>

  <div class="py-1">
    <CodeSample
      source={[
        "git clone https://github.com/modal-labs/modal-examples",
        "cd modal-examples",
        quote(cliArgs),
      ]}
      lang="bash"
      symbol="$"
    />
  </div>
</div>
